"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAddressValidationPopup = void 0;
var reselect_1 = require("reselect");
var checkoutSelectors_1 = require("../checkoutSelectors");
exports.getAddressValidationPopup = (0, reselect_1.createSelector)(checkoutSelectors_1.getCheckout, function (checkout) {
    return checkout.addressValidationPopup || {};
});
